require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-fleet-premium-elite.json") })
        }
      }, "path---en-fleet-premium-elite");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-fleet-premium-elite!./.cache/json/en-fleet-premium-elite.json
// module id = 1038
// module chunks = 231608221292675